import { getCsrfValue } from "../../api/ApiHelper";

import { type CompleteRegistrationFormValues } from "../CompleteRegistrationPage";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { AFFILIATE_FORM_KEY } from "~/feature/Affiliate/AffiliateFormSection";

interface CompleteAccountPostData extends CompleteRegistrationFormValues {
  passwordToken: string;
  newsletterOne: boolean;
  affiliateId?: string;
  isEnableFieldsTraining?: boolean;
}

interface Response {
  globalErrors: string[];
  validationResults: Dictionary<string[]>;
}

const apiUrl = resolveApiUrl("/registered/user/update");

export const putCompleteRegistration = (data: CompleteAccountPostData): Promise<Response> => {
  const isPreferredSalesPartner = !!data[AFFILIATE_FORM_KEY]?.id;
  return fetch(apiUrl, {
    body: JSON.stringify({
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password,
      checkPassword: data.confirmPassword,
      company: data.company,
      line1: data.address,
      line2: data.addressAdditional,
      zipCode: data.zipCode,
      city: data.city,
      country: data.country,
      phone: data.phone,
      salutationCode: data.salutation,
      titleCode: data.title,
      industrySector: data.industrySector,
      jobTitle: data.jobTitle,
      functionalArea: data.functionalArea,
      token: data.passwordToken,
      newsletterOne: data.newsletterOne,
      isPreferredSalesPartner: isPreferredSalesPartner,
      affiliateId: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.id ?? undefined : data.affiliateId,
      subsidiary: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.subsidiary ?? undefined : undefined,
      customerCategoryCode: data.isEnableFieldsTraining ? data.customerCategory : "",
      knowledgeAreaCode: data.isEnableFieldsTraining ? data.knowledgeArea : "",
      languageIsoCode: data.isEnableFieldsTraining ? data.language : "",
      vatNumber: data.isEnableFieldsTraining ? data.vat : "",
      lmsRequest: data.isEnableFieldsTraining,
    }),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "PUT",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json();
    }
  });
};
